// Company name generator utility using unique-names-generator
import { uniqueNamesGenerator, Config, adjectives, animals } from 'unique-names-generator';

/**
 * Generates a random company name in the format used by Docker
 * Examples: 'hopeful_bee', 'practical_zebra', 'competent_eagle'
 * Format: adjective_animal (all lowercase, alphanumeric only)
 */
export const generateCompanyName = (): string => {
  const name = uniqueNamesGenerator({
    dictionaries: [adjectives, animals],
    separator: '',
    style: 'lowerCase',
  } as Config);
  
  // Ensure it's within 8-30 characters
  if (name.length >= 8 && name.length <= 30) {
    return name;
  }
  
  // If too short, add random digits
  if (name.length < 8) {
    let extended = name;
    while (extended.length < 8) {
      extended += Math.floor(Math.random() * 10);
    }
    return extended.substring(0, 30);
  }
  
  // If too long, truncate
  return name.substring(0, 30);
};

/**
 * Validates that a company name meets requirements
 * - 8-30 characters
 * - lowercase letters and numbers only
 */
export const validateCompanyName = (name: string): { valid: boolean; error?: string } => {
  if (!name) {
    return { valid: false, error: 'Company name is required' };
  }
  
  if (name.length < 8 || name.length > 30) {
    return { valid: false, error: 'Company name must be 8-30 characters' };
  }
  
  if (!/^[a-z0-9-]+$/.test(name)) {
    return { valid: false, error: 'Company name can only contain lowercase letters, numbers, and dashes' };
  }
  
  return { valid: true };
};

/**
 * Checks if email is in valid format
 */
export const validateEmail = (email: string): { valid: boolean; error?: string } => {
  if (!email) {
    return { valid: false, error: 'Email is required' };
  }
  
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return { valid: false, error: 'Invalid email format' };
  }
  
  return { valid: true };
};
